import React, { PropsWithChildren, ReactElement } from 'react';

import { TContainerProperties } from './container.types';
import { StyledContainer } from './container.styled';

export function Container({
    children,
    fullWidth = false,
    className,
    as = 'div',
    narrow = false,
    autoAlign = true,
    ...otherProperties
}: PropsWithChildren<TContainerProperties>): ReactElement {
    return (
        <StyledContainer
            as={as}
            fullWidth={fullWidth}
            className={className}
            narrow={narrow}
            autoAlign={autoAlign}
            {...otherProperties}
        >
            {children}
        </StyledContainer>
    );
}
